import React from "react";
import ProgressTrackerTable from "./components/ProgressTrackerTable";

function Tables() {
  return <ProgressTrackerTable />;
}

export default Tables;
